export const commonEnum = {
    cacheSystemInfoKey:'cacheSystemInfoKey',
    cacheConfigInfoKey:'cacheConfigInfoKey',
}